import { getMaxRotateBounds, getTravelMap, TRAVEL_TYPES, } from '../../../utils/animationsUtils';
const name = 'BgRotate';
const angle = 22;
const properties = {
    hideOnStart: false,
    getMediaDimensions(width, height) {
        return getMaxRotateBounds(width, height, angle);
    },
    groups: ['animation', 'background'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
    },
};
function animate(kit, elements, duration, delay, { componentHeight, componentTop, siteHeight, viewPortHeight, ...params } = {}) {
    const sequence = kit.sequence(params);
    const { TOP_TO_BOTTOM, TOP_TO_TOP } = getTravelMap(componentHeight, componentTop, siteHeight, viewPortHeight, TRAVEL_TYPES.in_last_fold);
    sequence.add([
        kit.animate('BaseBgRotate', elements, duration, delay, {
            in: {
                start: TOP_TO_BOTTOM,
                end: TOP_TO_TOP,
                rotation: angle,
                ease: 'sine.out',
            },
        }),
    ]);
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=bgRotate.js.map